import {
  Component,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import Bank from '../../../../../core/data/models/bank.model';
import { FormInputDirective } from '../../../../../common/directives/form-input.directive';
import HealthInsured from '../../../../../core/data/models/health.insured.model';
import { AuthService } from '../../../../auth/services/auth.service';
import { ClaimRequestService } from '../../../services/claim.request.service';
import { SwalService } from '../../../../../common/services/swal.service';
import { RegisterBankAccountRequestDto } from '../../../../../core/data/dtos/register.bank.account.request.dto';
import {
  BANK_ACCOUNT_STATUS_CODE,
  ERROR_MESSAGES,
  ID_TYPE_CODES,
  PAYMENT_METHOD_CODE,
} from '../../../utils/claimRequestConstants';
import { lastValueFrom } from 'rxjs';
import { PlatformsService } from '../../../../../core/data/services/platforms.service';
import { LocalStorageService } from '../../../../../core/data/services/localStorage.service';

@Component({
    selector: 'app-bank-account-modal',
    imports: [ReactiveFormsModule, NgSelectModule],
    providers: [ClaimRequestService, SwalService],
    templateUrl: './bank-account-modal.component.html'
})
export class BankAccountModalComponent {
  @ViewChildren(FormInputDirective)
  validatedInputs!: QueryList<FormInputDirective>;
  @Input() banks: Bank[] = [];
  @Input() insuredHolder?: HealthInsured | null = null;
  @Input() onBankAccountAdded!: (bank: Bank) => void;

  accoundForm: FormGroup;

  accountTypes = [
    { id: 'A', label: 'Ahorro' },
    { id: 'C', label: 'Corriente' },
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private swalService: SwalService,
    private authService: AuthService,
    private claimRequestService: ClaimRequestService,
    private platformService: PlatformsService,
    private localStorageService:LocalStorageService
  ) {
    this.accoundForm = this.fb.group({
      accountType: [null, Validators.required],
      accountNumber: [
        null,
        [Validators.required, Validators.pattern(/^[0-9]+$/)],
      ],
      bank: [null, Validators.required],
    });
  }

  filterNumbersOnly(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '');

    this.accoundForm
      .get('accountNumber')
      ?.setValue(input.value, { emitEvent: false });
  }

  onSubmit = async () => {
    const values = this.accoundForm.value;
    const cUser = this.localStorageService.getSessionToken()?.email;

    const user = this.authService.user;
const username = (this.platformService.isIOs() || this.platformService.isEmbeddedApp()) ? cUser : user?.username;
    if (this.accoundForm.invalid) {
      this.accoundForm.markAllAsTouched();
      return;
    }

    const request: RegisterBankAccountRequestDto = {
      idNumber: this.insuredHolder?.idNumber!,
      idType: ID_TYPE_CODES.CEDULA,
      paymentMethod: PAYMENT_METHOD_CODE.TRANSFERENCIA,
      bankAccountType: values.accountType,
      accountNumber: values.accountNumber,
      bankNumber: values.bank,
      isDefault: true,
      active: true,
      cUser: username || '',
      wDate: new Date().toISOString(),
      status: BANK_ACCOUNT_STATUS_CODE.ACTIVO,
      emailAddress: username || '',
    };

    this.swalService.showLoading();

    try {
      const result = await lastValueFrom(
        this.claimRequestService.registerBankAccount(request),
      );

      if (result?.succeeded) {
        const newBank: Bank = {
          id: values.bank,
          description:
            this.banks.find((bank) => values.bank === bank.id)?.description +
              ' - ' +
              values.accountNumber || 'Sin descripción',
        };

        if (this.onBankAccountAdded) {
          this.onBankAccountAdded(newBank);
        }
        this.swalService.dismiss();
        this.activeModal.close(this.accoundForm.value);
      } else {
        this.swalService.dismiss();
        this.swalService.error(
          ERROR_MESSAGES.UNEXPECTED_ERROR_CREATING_REQUEST,
        );
      }
    } catch (error) {
      this.swalService.dismiss();
      this.swalService.error(ERROR_MESSAGES.UNEXPECTED_ERROR_CREATING_REQUEST);
    }
  };

  cancel() {
    this.activeModal.dismiss();
  }
}
